import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventListPublicChild from "./EventListPublicChild";

const EventListPublic = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventListPublicChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventListPublic;
